module.exports = __webpack_public_path__ + "static/media/prepaid.e08b8f5c.png";